<template>
	<div class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5);">
		<div class="modal-dialog modal-lg modal-fullscreen-sm-down" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h5 class="modal-title"><i class="fas fa-paperclip me-2"></i>Allegati - {{ titolo }}</h5>
					<button type="button" class="btn-close btn-close-white" @click="close()"></button>
				</div>

				<div class="modal-body">
					<div style="max-height: 320px; overflow-y: auto;">
						<table class="table table-sm table-hover mb-0">
							<thead>
								<tr>
									<th>File</th>
									<th style="width:22%;">Caricato il</th>
									<th style="width:22%;">Da</th>
									<th style="width:10%;" class="text-center">Azioni</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="allegato in allegati" :key="allegato.ID_ALLEGATO">
									<td class="text-break">
										<a href="#" @click.prevent="apri(allegato)"><i class="far fa-file fa-fw me-1"></i>{{ allegato.NOME_FILE }}</a>
									</td>
									<td class="fs-sm">{{ filters.formatDateTime(allegato.DATA_ADD, 'YYYY-MM-DD HH:mm:ss') }}</td>
									<td class="fs-sm">{{ allegato.NOME_UTENTE }}</td>
									<td class="text-center">
										<a href="#" v-if="canUpdate" class="text-danger" title="Elimina" @click.prevent="elimina(allegato)"><i class="ph-trash"></i></a>
									</td>
								</tr>
								<tr v-if="allegati.length == 0">
									<td colspan="4" class="text-center text-muted">Nessun allegato</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="modal-footer">
					<button type="button" v-if="canUpdate" class="btn btn-info" @click="showUpload = true"><i class="fas fa-cloud-upload-alt me-1"></i>Carica allegato</button>
					<button type="button" class="btn btn-secondary" @click="close()">Chiudi</button>
				</div>
			</div>
		</div>

		<div v-if="showUpload" class="modal fade show" tabindex="-1" role="dialog" style="display: block; background: rgba(0, 0, 0, 0.5); z-index: 1060;">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header bg-secondary text-white">
						<h5 class="modal-title"><i class="fas fa-cloud-upload-alt me-2"></i>Carica allegato</h5>
						<button type="button" class="btn-close btn-close-white" @click="showUpload = false"></button>
					</div>
					<div class="modal-body">
						<Upload
							url="core/basic/upload"
							:args="argsUpload"
							@onsuccess="onUploadSuccess"
							@onerror="onUploadError"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Upload from './utils/Upload.vue';

// Allegati di un progetto (tipo 'progetto') o di una voce (tipo 'voce'): le route backend
// sono le stesse sotto theb/progetto/ e theb/voce/, i permessi derivano dal path.
export default {
	name: 'ModalAllegati',
	components: {
		Upload
	},
	props: {
		tipo: {
			type: String,
			required: true
		},
		id: {
			type: [Number, String],
			required: true
		},
		titolo: {
			type: String,
			default: ''
		}
	},
	emits: ['close'],
	data() {
		return {
			allegati: [],
			showUpload: false,
			filters: global.filters
		};
	},
	computed: {
		chiave() {
			return this.tipo == 'voce' ? 'ID_VOCE' : 'ID_PROGETTO';
		},
		canUpdate() {
			return this.$root.hasFunzionalita(this.tipo == 'voce' ? 'VOCE_UPDATE' : 'PROGETTO_UPDATE');
		},
		argsUpload() {
			return { modalita: 'THEB_uploadAllegato', [this.chiave]: this.id };
		}
	},
	mounted() {
		this.getAllegati();
	},
	methods: {
		getAllegati() {
			utils.get('theb/' + this.tipo + '/allegati', { [this.chiave]: this.id }, (response) => {
				if (response.esito == 0) {
					this.allegati = response.data;
				}
			});
		},
		apri(allegato) {
			utils.ajaxBlob('theb/' + this.tipo + '/allegato', { ID_ALLEGATO: allegato.ID_ALLEGATO }, (blob) => {
				// download con nome esplicito: un blob URL aperto in una nuova tab, se il browser scarica invece di mostrare, prende come nome il GUID senza estensione
				const a = document.createElement('a');
				a.href = URL.createObjectURL(blob);
				a.download = allegato.NOME_FILE;
				a.click();
				setTimeout(() => URL.revokeObjectURL(a.href), 1000);
			}, true, 'GET');
		},
		elimina(allegato) {
			utils.alert.confirm('Eliminare l\'allegato selezionato?', () => {
				utils.put('theb/' + this.tipo + '/allegato-elimina', { ID_ALLEGATO: allegato.ID_ALLEGATO }, (response) => {
					if (response.esito == 0) {
						utils.alert.success('Allegato eliminato');
						this.getAllegati();
					}
				});
			}, this.$root);
		},
		onUploadSuccess() {
			this.getAllegati();
			this.showUpload = false;
		},
		onUploadError(response) {
			utils.alert.warning(response.messaggio || 'Errore upload');
		},
		close() {
			this.$emit('close');
		}
	}
};
</script>

<style scoped>
.modal {
	z-index: 1050;
}
</style>
